<template>
    <div class="form-group col-12 mt-4 pl-0">
        <div v-if="bloqueio_tela" class="col alert alert-warning text-center mb-4" role="alert"
            style="margin-bottom: 0px; margin-right: 3px;">
            Seu usuário não tem permissão para criar OS Proativa!
        </div>
        <div class="card ml-3 pt-2 pb-3 pl-2" v-if="!bloqueio_tela">
            <video id="video" width="600" height="400" style="margin-left:1%" v-show="screenQrCode"></video>
            <div class="col-12 text-left striped-sm">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Operação') }}:</div>
                <div class="row">
                    <div class="col-12 col-sm-12 col-lg-12 mb-2">
                        <v-select :options="operacoes" :placeholder="$t('Operação')" v-model="operacao"
                            @input="getPlacas(operacao)">
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="col-12 text-left striped-sm">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Placa') }}: 
                    <span style="color: red" v-if="bloqueio_qrcode">Você deve selecionar a placa pelo QrCode!</span></div>
                <div class="row">
                    <div class="col-12 col-sm-10 col-lg-10 mb-2">
                        <v-select :disabled="bloqueio_qrcode" :options="veiculos" :placeholder="$t('Placa')" v-model="placa"
                            @input="getSegmentos(placa)">
                        </v-select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-outline-success" @click="qrCode">QrCode</button>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-1 text-left">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Segmento') }}:</div>
                <v-select :disabled="disabledSegmento" :options="grupos" :placeholder="$t('Segmento')"
                    @input="getProblemas(nr_segmento)" v-model="nr_segmento">
                </v-select>
            </div>
            <div class="col-12 mt-1 text-left">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Problemas') }}:</div>
                <select :disabled="disabledProblema" class="form-control" name="" id="selectProblema"
                    v-model="nr_problema">
                    <option v-for="problema in problemas" :key="problema.nr_sequencial" :value="problema.nr_sequencial">
                        {{ problema.ds_conjunto }}
                    </option>
                </select>
            </div>
            <div class="col-12 mt-1 text-left ">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Descrição do Problema') }}:</div>
                <textarea v-model="descricaoProblema" type="text" class="form-control"
                    :placeholder="$t('Descrição do Problema')"></textarea>
            </div>

            <div class="col-12 mt-1 text-left">
                <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">{{ $t('Upload Arquivos') }}:</div>
                <upload-arquivos></upload-arquivos>
            </div>

            <div class="card-footer mt-4">
                <button type="button" class="btn btn-success mr-3" @click="validaOsIgualJaAberta">{{ $t('Gerar OS')
                    }}</button>
                <router-link to="/" class="btn btn-danger mr-2">
                    <i class="fas fa-close"></i>
                    {{ $t('Cancelar') }}
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */

import UploadArquivos from './Modais/UploadArquivos.vue'

export default {

    name: 'NovaOsComponent',
    data() {
        return {
            nr_segmento: '',
            placa: '',
            operacao: '',
            local: '',
            descricaoProblema: '',
            itensOs: [],
            selectItemOs: '',
            screenQrCode: false,
            nr_problema: '',
            ds_problema: '',
            problemas: [],
            disabledProblema: true,
            segmentos: '',
            disabledSegmento: true,
            disabledPlaca: true,
            tipoVeiculo: '',
            bloqueio_tela: false,
            bloqueio_qrcode: false
        }
    },

    components: {
        UploadArquivos
    },

    created() {
        this.getItensOs()
        this.$store.dispatch('veiculo/fetchFromApi').then(response => {
            console.log(response.data.tela_bloqueio)
            const val = response.data.tela_bloqueio

            if(val){
                if(val.bloqueia_tela){
                    this.bloqueio_tela = true
                }
                if(val.bloqueia_qrcode){
                    this.bloqueio_qrcode = true
                }
            }
        })
    },
    computed: {
        veiculos() {
            const items = this.$store.getters['veiculo/itemsTemp']

            if (!items) {
                this.$store.dispatch('veiculo/fetchFromApi')
                return []
            }

            return items.map(item => {
                return {
                    ...item,
                    label: item.nr_placa
                }
            })
        },
        operacoes() {
            const operacoes = this.$store.getters['veiculo/projetos']

            if (!operacoes) {
                this.$store.dispatch('veiculo/fetchFromApiProjetos')
                return []
            }

            return operacoes.map(item => {
                return {
                    ...item,
                    label: item.ds_projeto
                }
            })
        },
        grupos() {
            const grupos = this.$store.getters['frotaConjunto/gruposNovaOs']

            if (!grupos) {
                this.$store.dispatch('frotaConjunto/getGruposNovaOs', { operacao: 0 })
                return []
            }

            return grupos.map(grupo => {
                return {
                    ...grupo,
                    label: grupo.ds_grupo
                }
            })
        },
    },
    methods: {
        getPlacas(nr_operacao) {
            this.disabledPlaca = false
            this.disabledSegmento = true
            this.disabledProblema = true

            this.nr_problema = ''
            this.nr_segmento = ''
            this.placa = ''
            this.tipoVeiculo = ''

            if (nr_operacao == null) {
                this.$store.commit('veiculo/setPlacasOrigin')
            } else {
                this.$store.dispatch('veiculo/setPlacasFromProjeto', { nr_seq_projeto: nr_operacao.nr_sequencial })
            }

        },

        getSegmentos(veiculo) {
            console.log(veiculo)
            this.nr_segmento = ''
            this.tipoVeiculo = veiculo.cd_tipoveiculo

            this.disabledProblema = true
            const operacao = veiculo.veiculo_filial[0].nr_seq_operacao

            this.$store.dispatch('frotaConjunto/getGruposNovaOs', { operacao: operacao })

            this.disabledSegmento = false

        },

        async getProblemas(nr_segmento) {
            const params = {
                tipo_veiculo: this.tipoVeiculo,
                nr_problema: nr_segmento.nr_sequencial
            }

            this.$store.dispatch('osItemExecucao/getProblemas', { params: params }).then(response => {
                this.disabledProblema = false
                this.problemas = response.data.problema
            }).catch((error) => {
                console.log(error)
            })
        },

        async qrCode() {
            this.screenQrCode = true

            const scanner = new Instascan.Scanner({
                video: document.querySelector('#video')
            })

            scanner.addListener('scan', content => {

                this.screenQrCode = false
                const stringPlaca = content

                const placaBruto = stringPlaca.indexOf('nr_placa')

                const placa = stringPlaca.substring(placaBruto + 9)
                const items = this.$store.getters['veiculo/itemsTemp']

                // console.log(items)
                const veiculoPlaca = items.filter(obj => obj.nr_placa == placa)

                this.getSegmentos(veiculoPlaca[0])
                this.placa = veiculoPlaca[0].nr_placa
                scanner.stop()
            })

            Instascan.Camera.getCameras().then((cameras) => {
                let selectedCamera;

                if (cameras.length > 0) {
                    // scanner.start(cameras[2]);
                    for (let c = 0; c < cameras.length; c++) {
                        if (cameras[c].name.indexOf('back') != -1) {
                            selectedCamera = cameras[c];
                        }
                    }

                    if (!selectedCamera) selectedCamera = cameras[0];
                }

                if (selectedCamera) {
                    scanner.start(selectedCamera);
                } else {
                    console.error("No cameras found.");
                }
            })
        },

        async getItensOs() {
            this.$store.dispatch('osItemExecucao/getItensOs').then(response => {
                this.itensOs = response.data.itensOs
            }).catch((error) => {
                console.log(error)
            })
        },

        validaOsIgualJaAberta() {
            const data = {
                nr_segmento: this.nr_segmento.nr_sequencial,
                nr_problema: this.nr_problema,
                placa: this.placa.nr_placa
            }

            this.$store.dispatch('osTipo/getOsLancada', { data: data }).then(response => {
                if (response.length !== 0) {
                    this.$swal.fire({
                        title: 'Oops!',
                        text: 'Já existe uma OS aberta com estas informações',
                        icon: 'error'
                    })
                } else {
                    this.novaOs()
                }
            }).catch((error) => {
                throw new Error(error)
            })
        },

        validaInf() {
            if (!this.placa) {
                this.$swal.fire({
                    title: 'Insira uma placa',
                    text: 'Preencha todas as informações',
                    icon: 'error'
                })
            } else if (!this.nr_segmento) {
                this.$swal.fire({
                    title: 'Insira um Segmento',
                    text: 'Preencha todas as informações',
                    icon: 'error'
                })
            } else if (!this.nr_problema) {
                this.$swal.fire({
                    title: 'Insira um Problema',
                    text: 'Preencha todas as informações',
                    icon: 'error'
                })
            } else if (!this.descricaoProblema) {
                this.$swal.fire({
                    title: 'Insira uma Descrição',
                    text: 'Preencha todas as informações',
                    icon: 'error'
                })
            } else {
                return true
            }
        },

        limparCampos() {
            this.placa = '',
                this.nr_segmento = '',
                this.nr_problema = ''
            this.disabledProblema = true
            this.descricaoProblema = ''
        },

        novaOs() {
            if (this.validaInf()) {
                let mecanicoOs = JSON.parse(localStorage.filial)

                const execucao = {
                    placa: this.placa.nr_placa ? this.placa.nr_placa : this.placa,
                    descricaoProblema: this.descricaoProblema,
                    nr_segmento: this.nr_segmento.nr_sequencial,
                    nr_problema: this.nr_problema,
                    descSegmento: this.nr_segmento.ds_grupo,
                    idMecanico: mecanicoOs.tecnicoId
                }

                this.$store.dispatch('osItemExecucao/novaOs', { data: execucao }).then(response => {
                    // this.$store.dispatch('os/refreshNavs')
                    // console.log(response.data)

                    if (document.getElementById('formFiles').value != '') {
                        const files = this.$store.state.os.filesUpload

                        const formData = new FormData();

                        for (let i = 0; i < files.length; i++) {
                            formData.append('files[]', files[i]);
                        }

                        this.$store.dispatch(`os/uploadFiles`, { data: formData, nrSeqOs: response.data.nr_seq_os })
                    }
                    const filial = this.$store.getters['filial/filial']

                    if(filial.tipoPerfilTerminal == 'E'){
                        this.$router.push('/osEmpilhadeira')
                    } else {
                        this.$router.push('/')
                    }

                    this.$swal.fire({
                        title: 'Sucesso!',
                        text: 'Ordem de Serviço criada com Sucesso',
                        icon: 'success'
                    })
                    this.limparCampos()
                }).catch((error) => {
                    this.$swal.fire({
                        title: 'Oops!',
                        text: 'Falha ao parar execução. Tente novamente.',
                        icon: 'error'
                    })
                    console.log(error)
                })
            }
        }

    }
}
</script>

<style scoped>
    .card-footer {
        background-color: #fff !important;
        border: none;
    }

    .labelNovaOs {
        padding: 1px;
        color: rgb(29, 29, 29);
        margin-bottom: 1px;
    }

    #video {
        transform: scaleX(1) !important;
    }

    @media screen and (max-width: 980px) {
        #video {
            width: 333px !important;
            height: 270px !important;
        }
    }
</style>
